module.exports = "/_next/static/images/mobileLines-f87e7493544ad36ba81879809116b8a7.png.webp";